import React from 'react';

const PriceDisplay = ({ price }) => {
    return (
        <span className="price">
            {price === 0 ? (
                <span className="free-badge">رایگان</span>
            ) : (
                `${price.toLocaleString()} تومان`
            )}
        </span>
    );
};

export default PriceDisplay;

